/**
 * What a reader sees when their email already has an account under another
 * sign-in method ([[BUGS #429]]). Deliberately does not name that method —
 * with email-enumeration protection on, Firebase hides it, and naming it would
 * tell a stranger how an address signs in — and promises nothing that does not
 * exist yet: linking arrives with ROADMAP "One person, one account, any sign-in
 * method", item 3. Worded as a welcome rather than an error: the reader has
 * done nothing wrong — they are a returning customer.
 */
export const ACCOUNT_EXISTS_MESSAGE =
  'Welcome back! This email already has an IndexAlpha account. Sign in with the option you used last time.';
